export default {"src":"/_next/static/media/water.e6a47e2d.svg","height":96,"width":96};